import STATE_STANDARD from '../../constants/state-standard.json';
import STUDENT_FEATURES from '../../constants/student-features';
import useUserContext from '../context/use-user-context';

// Exports
// -------

export default function useStudentStateStandardId() {
  const { activeStudent } = useUserContext();
  const stateStandardsEnablement = activeStudent?.getEnablement(
    STUDENT_FEATURES.stateStandardsAssessments
  );

  return STATE_STANDARD[stateStandardsEnablement?.configuration?.standard_type];
}
